<script>
    import {postOfferData} from "../repo";
    import FilePicker from "./FilePicker.svelte";
    import MaskInput from "svelte-input-mask";

    export let offerData;
    export let offerItems;
    export let offerSent;
    let loading;
    let error;

    //let files: File[] = []
    export let selectedFiles = {
        upload: [],
        delete: []
    };

    function send(e) {
        e.preventDefault();
        window.grecaptcha.ready(function() {
            window.grecaptcha.execute('6LcXI0YbAAAAAJSu_O23rYhuW8ykGBPGSUx8tI-G', {action: 'submit'}).then(function(token) {
                loading = true
                error = false
                offerData.items = []
                offerItems.forEach(item => {
                    offerData.items.push(item.toOfferRequestItem())
                })
                postOfferData(offerData, selectedFiles.upload, token).then(success => {
                    gtag('event', 'generate_lead', {
                        'event_category' : 'Ajánlatkérés'
                    })
                    fbq('trackCustom', 'offerRequest')
                    offerSent = true
                    loading = false
                }, error => {
                    loading = false
                    error = true
                })
            });
        });
    }

    const handlePhone = ({ detail }) => {
        //console.log(detail.inputState.unmaskedValue); // stores the value of input
        offerData.requesterPhone = detail.inputState.unmaskedValue

      /*  if (detail.inputState.unmaskedValue.length < 12) {
            document.getElementById("phone").setCustomValidity("Kérlek a formátumban add meg: +36 (30) 123 4567");
        } else {
            document.getElementById("phone").setCustomValidity('');
        }*/
    };

/*    onMount(async () => {
        document.getElementById("phone").setCustomValidity("Kérlek a formátumban add meg: +36 (30) 123 4567");
    });*/


</script>

<div class="self-center lg:self-start rounded-md px-8 py-2 mb-8 bg-blue-800 mt-12">
    <h2 class="p-2 w-full text-2xl font-semibold">Árajánlat beküldése</h2>
</div>
<div class="w-full">
    <form id="form" class="pt-6 pb-8 mb-4" on:submit={(e) => {send(e)}}>
        <div class="flex flex-col lg:flex-row">
            <div class="p-2 w-full">
                <label class="block text-white text-sm font-bold mb-2" for="name">
                    Vezetéknév és keresztnév
                </label>
                <input required
                       class="bg-primary-100 shadow appearance-none border border-white rounded w-full py-2 px-3 text-white leading-tight focus:outline-none focus:shadow-outline"
                       minlength="5" id="name" type="text" placeholder="Név"
                       bind:value="{offerData.requesterName}">
            </div>
            <div class="p-2 w-full">
                <label class="block text-white text-sm font-bold mb-2" for="email">
                    Email
                </label>
                <input required
                       class="bg-primary-100 shadow appearance-none border border-white rounded w-full py-2 px-3 text-white mb-3 leading-tight focus:outline-none focus:shadow-outline"
                       id="email" type="email" placeholder="Email cím"
                       bind:value="{offerData.requesterEmail}">
            </div>
        </div>
        <div class="flex flex-col lg:flex-row">
            <div class="p-2 w-full">
                <label class="block text-white text-sm font-bold mb-2" for="email">
                    Település
                </label>
                <input required
                       class="bg-primary-100 shadow appearance-none border border-white rounded w-full py-2 px-3 text-white mb-3 leading-tight focus:outline-none focus:shadow-outline"
                       minlength="3" id="city" type="text" placeholder="Település"
                       bind:value="{offerData.requesterCity}">
            </div>
            <div class="p-2 w-full">
                <label class="block text-white text-sm font-bold mb-2" for="email">
                    Telefonszám
                </label>
                <MaskInput
                        autocomplete="new-password"
                        id="phone"
                        required
                        alwaysShowMask
                        mask='+00 (00) 000 0000'
                        size={20}
                        showMask
                        maskChar="_"
                        defaultValue="36"
                        value="36"
                        on:change={handlePhone}
                        class="bg-primary-100 shadow appearance-none border border-white rounded w-full py-2 px-3 text-white mb-3 leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>
        </div>
        <div class="p-2">
            <label class="block text-white text-sm font-bold mb-2" for="comment">
                Megjegyzés
            </label>
            <textarea class="w-full py-2 px-3 text-white bg-primary-100 rounded border-white" autocomplete=off
                      id="comment" name="comment" placeholder="Megjegyzés"
                      bind:value="{offerData.requesterComment}"></textarea>
        </div>
        <FilePicker name="Fajlok" bind:selected={selectedFiles}/>
        <div class="p-2 pt-4 flex items-center justify-start">
            <input required type="checkbox" id="dataCheck" class="mr-4 h-7 w-7 rounded">
            <label class="text-md" for="dataCheck">Az adatvédelmi nyilatkozat tartalmát megismertem és elfogadom azt.</label>
        </div>
        <a class="underline p-2 text-md" target="_blank" href="https://pergolagroup.hu/adatvedelem/">Az adatvédelmi nyilatkozat ide kattintva érhető el.</a>
        {#if !loading}
            <div class="flex justify-end px-4 py-1">
                <button type="submit" value="Submit"
                        class="bg-red-800 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
                    Beküldés
                </button>
            </div>
        {/if}
        {#if loading}
            <div class="flex justify-end">
                <div class="flex flex-col">
                    <div class="flex justify-center text-center items-center px-4 py-1">
                        <img src="/img/loading.svg" alt="loading"/>
                    </div>
                    <div class="flex justify-center text-center items-center px-4 py-1">
                        <span class="text-xs">Küldés folyamatban...</span>
                    </div>
                </div>
            </div>
        {/if}
        {#if error}
            <div class="flex justify-end">
                <div class="flex flex-col">
                    <div class="flex justify-center text-center items-center px-4 py-1">
                        <span class="text-xs text-red-800">Hiba történt, kérlek próbáld újra később!</span>
                    </div>
                </div>
            </div>
        {/if}

    </form>
    <div class="w-full flex justify-start text-white text-xs">
        * A ajánlatban szereplő termékek és az oldalon megjelenített vizuális árbrázolások eltérhetnek egymástól. Egyes termékek valódi kinézetéről a főoldalon található illusztrációkból tájékozódhat.
    </div>
</div>

